import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance, nextTick, onBeforeUnmount, onMounted, PropType, reactive, ref } from 'vue';
import Tab from '@/modules/Chat/components/Tab.vue';
import SearchChat from '@/modules/Chat/components/SearchChat.vue';
import ProjectRepository from '@/repositories/ProjectRepository';
import { EventBus } from '@/helpers/EventBusHelper';
import { EventBusEvents } from '@/enums/global/EventBusEvents';
import { UserRepository } from '@/repositories/UserRepository';
import { TabKeys } from '@/enums/components/CmsIndex/TabKeys';
import { fetchChatProjects } from '@/modules/Chat/helpers/ChatHelper';
import Project from '@/models/Project';
import router from '@/router';


export default /*#__PURE__*/_defineComponent({
  __name: 'Sidebar',
  props: {
    selectedProjectId: {
        type: String as PropType<string | null>,
        default: null,
    },
},
  setup(__props) {

const props = __props;



const { proxy } = getCurrentInstance()!;
const vm = proxy as any;

const isSidebarLoading = ref(true);
const tabKeys = TabKeys;
const activeTabKey = ref(TabKeys.MyProjects);
const hasUrlIdYieldedProject = ref(false);

const searchOptions = reactive({
    page: 1,
    size: 10,
    query: '',
    total: 0,
});

const currentUser = computed(() => UserRepository.getCurrentUser());
const filteredTabItems = computed(() => ProjectRepository.getChatProjects());

function searchChatProjects(query: string) {
    searchOptions.query = query;
    searchOptions.page = 1;

    fetchChatProjectsFromRepository();
}

async function onChangeTab(key: TabKeys) {
    activeTabKey.value = key;
    searchOptions.page = 1;

    await fetchChatProjectsFromRepository();
    emitDefaultProjectSelectionOrRemoveIdFromUrl();
}

function onPaginationChange() {
    nextTick(() => {
        fetchChatProjectsFromRepository();
    });
}

function onUpdatePagination({ totalNumber }: { totalNumber: number }) {
    if (totalNumber == null) {
        return;
    }

    searchOptions.total = totalNumber;
}

async function fetchChatProjectsFromRepository() {
    if (currentUser.value == null) {
        return Promise.reject();
    }
    isSidebarLoading.value = true;

    try {
        await fetchAndPreselectProjectFromUrlParams();
        await fetchChatProjects({
            activeTabKey: activeTabKey.value,
            userId: currentUser.value.id,
            searchOptions,
        });
    } catch (error) {
        onError((error as Error).message);
        return Promise.reject();
    } finally {
        isSidebarLoading.value = false;
    }
    return Promise.resolve();
}

function onError(message: string) {
    vm.$notification.error({
        message: vm.$t('Dogodila se greška') as string,
        description: message,
    });
    isSidebarLoading.value = false;
}

function emitDefaultProjectSelectionOrRemoveIdFromUrl() {
    if (filteredTabItems.value.length <= 0) {
        return;
    }

    if (!hasUrlIdYieldedProject.value) {
        EventBus.$emit(EventBusEvents.openChatProject, filteredTabItems.value[0].projectInfo.projectId);
    } else {
        router.replace(`/chat`);
    }
}

async function fetchAndPreselectProjectFromUrlParams() {
    if (router.currentRoute.params.id != null) {
        let response;
        try {
            response = await Project.getById(router.currentRoute.params.id);
        } catch (e) {
            vm.$notification.info({
                message: vm.$t('Projekt s tim ID-om ne postoji') as string,
                description: ``,
            });
            return Promise.resolve();
        }

        if (response != null) {
            hasUrlIdYieldedProject.value = true;
            EventBus.$emit(EventBusEvents.openChatProject, router.currentRoute.params.id);
            return Promise.resolve();
        }
    }

    return Promise.resolve();
}

onMounted(async () => {
    EventBus.$on(EventBusEvents.emitProjectPagination, onUpdatePagination);

    await fetchChatProjectsFromRepository();
});

onBeforeUnmount(() => {
    EventBus.$off(EventBusEvents.emitProjectPagination, onUpdatePagination);
});

return { __sfc: true,props, proxy, vm, isSidebarLoading, tabKeys, activeTabKey, hasUrlIdYieldedProject, searchOptions, currentUser, filteredTabItems, searchChatProjects, onChangeTab, onPaginationChange, onUpdatePagination, fetchChatProjectsFromRepository, onError, emitDefaultProjectSelectionOrRemoveIdFromUrl, fetchAndPreselectProjectFromUrlParams, Tab, SearchChat }
}

})